import {Data} from './Data';
import * as _ from "lodash";

/**
 * @hidden
 */
export class Price {
	public static decimals:string = ',';
	public static thousands = '\xa0';

	// Price formatting
	static print(value) {
		let dec = Math.floor(value);
		let flt = (value % 1);
		let dpt = [];
		while (dec) {
			if (dpt.length)  // pad previous segment with zeros
				dpt[0] = String('000' + dpt[0]).slice(-3);
			dpt.unshift((dec % 1000).toString());
			dec = Math.floor(dec / 1000);
		}
		if (!dpt.length)
			dpt = ['0'];
		return dpt.join(Price.thousands) + Price.decimals + (flt ? Math.round(flt * 100) : '-');
	}
}


/**
 * Product configuration
 */
export class ItemConfig {
	public hash: string;
	protected _configString: string = null;
	protected _price: number = null;
	public label: string;

	/**
	 * @hidden
	 */
	constructor(
			protected catalog: { [itemID: string]: Data.CatalogItem },
			public article: string,
			public accessories: { [aID:string]: string} ,
			/** extraProperties Additional selected value details (such as label, alias, icon...) */
			public extraProperties: { [pID:string]: PropertyDetail},
			public meta: { [mVar: string]: string } = {}
	) {
		let md5 = require('md5');
		accessories.article = article;

		this.hash = this.article + ':' + md5(this.configString);

		if (!this.catalog.hasOwnProperty(article))
			throw new Error(`Invalid article: ${article}`);

		this.label = this.catalog[article].label;
	}

	/**
	 * Whether to show configuration entries which has zero price
	 */
	public static detailFreeItems = false;

	/**
	 * Creates summary table for current variant
 	 * @param _$
	 */
	detailTable(_$:JQueryStatic) {
		let table = _$('<table class="detail"></table>');
		_.forEach(this.accessories, (pVal) => {
			if (this.catalog.hasOwnProperty(pVal) && (ItemConfig.detailFreeItems || this.catalog[pVal].price))
				table.append('<tr><th>' + this.catalog[pVal].label + '</th>' +
						// '<td class="cnt"></td>' +
						'<td class="price">' + Price.print(this.catalog[pVal].price) + '</td>' +
						'</tr>');
		});
		return table;
	}

	/**
	 * Creates unique sting for this configuration containing article numbers
	 * This allows to have same variant of product with different property values (i.e. same variant, different color)
	 */
	get configString() {
		if (!this._configString) {
			this._configString = this.article;
			_.forEach(this.extraProperties, (pVal:PropertyDetail) => {
				this._configString += ':' + pVal.id;
			});
			_.forEach(this.accessories, (aID, aVal) => {
				if (aVal && (aVal !== '-') && (aID !== 'article') && !this.extraProperties.hasOwnProperty(aID))
					this._configString += '-' + aVal;
			});
		}
		return this._configString;
	}


	/**
	 * Full variant label (including property description)
	 */
	getLabel():string {
		let label = this.label;
		_.forEach(this.extraProperties, (pVal:PropertyDetail) => {
			label += ', ' + pVal.label;
		});
		return label;
	}

	/**
	 * @hidden
	 */
	getRuleSet(): { [prop:string]: string } {
		let result: { [prop:string]: string } = {};
		_.forEach(this.extraProperties, (pVal:PropertyDetail, pID: string) => {
			result[pID] = pVal.id;
		});
		return result;
	}

	/**
	 * Configuraion price
	 */
	get price():number {
		let ic = this;
		if (ic._price === null) {
			// ic._price = catalog[ic.article].price;  // basic variant price
			_.forEach(ic.accessories, (pVal) => {
				if (this.catalog.hasOwnProperty(pVal))
					ic._price += this.catalog[pVal].price; // accessories price
			});
		}
		return ic._price;
	}
}

/**
 * @hidden
 */
export class PropertyDetail{
	public id: string;
	public label: string;
	public price: number;

	/**
	 * @hidden
	 */
	constructor(data){
		Object.assign(this, data);
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/ItemConfig.ts